import api from './api';

/**
 * Obtiene las tasas de cambio desde el backend.
 * @returns {Promise<object>} Un objeto con las tasas de cambio (ej. { "ARS": 910.5, "EUR": 0.92 }).
 */
export const fetchExchangeRates = async () => {
  try {
    const { data } = await api.get('/currency/rates');
    return data;
  } catch (error) {
    console.error('Failed to fetch exchange rates:', error);
    // Devuelve null para que el resto de la app pueda manejar el fallo.
    return null;
  }
};
